export let baseUrl = null
export let config = null;
export let MIN_ORDER_AMOUNT = null
export let Customer_Port = null
export let FolderPath = null
export let BuildVersion = null
export let AllowedExtensions = null

export const getConfig = () => {
    if (!config) {
      throw new Error('Config has not been loaded!');
    }
    return config;
  };

  export const loadConfig = async () => {
    const response = await fetch(`./config.json?v=${Date.now()}`);
    config = await response.json();
    baseUrl = config.baseUrl;
    MIN_ORDER_AMOUNT = config.MIN_ORDER_AMOUNT
    Customer_Port = config.Customer_Port
    FolderPath = config.FolderPath
    BuildVersion = config.BuildVersion
    AllowedExtensions = config.AllowedExtensions
}